var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('list-page',{attrs:{"name":"Gamulation Set","use":"_id","display":_vm.display,"page-prefix":"/blade/gamesets","fetch":_vm.getGameSets,"remove":_vm.deleteGameSet}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-77d2b188","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/blade/pages/GameSetList.vue
// module id = null
// module chunks = 